"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLogoZero = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconLogoZero = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.15125 18.8515L5.14972 18.8499C2.13412 15.0263 2.3764 9.4557 5.91619 5.91309C9.45674 2.37155 15.0255 2.12949 18.8479 5.14647L18.8494 5.14761C15.3394 0.466947 8.29789 0.0304559 4.19506 4.1915C1.16879 7.14753 0.449562 12.0286 2.4846 15.732C3.14212 16.9487 4.05411 18.0244 5.15125 18.8515Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.5154 8.26754C20.8579 7.05086 19.9466 5.97473 18.8494 5.14761C18.8494 5.14837 18.8503 5.14923 18.851 5.14999C21.8651 8.97367 21.6244 14.5427 18.0846 18.0853C14.5417 21.6265 8.97454 21.8689 5.15285 18.8535C5.15209 18.8531 5.15201 18.8519 5.15125 18.8515L5.15056 18.8531C8.65987 23.5349 15.7029 23.9676 19.8057 19.8096C22.8304 16.852 23.5504 11.9724 21.5154 8.26754Z",
    fill: color
  }))));
};
exports.IconLogoZero = IconLogoZero;
//# sourceMappingURL=IconLogoZero.js.map